// extracted by mini-css-extract-plugin
module.exports = {"layout":"Default_layout__ix7Sv","layoutContent":"Default_layout-content__3NAN3"};